import {bindable, customElement} from "aurelia-framework";

@customElement('raago-img-banner-section')
export class RaagoImgBannerSection {
  @bindable() imgSrc_s;
  @bindable() imgSrc_m;
  @bindable() imgSrc_l;
  @bindable() imgAlt;
  @bindable() href; //  can also use like this: route-href="route: my-page; params.bind: {test: 'test2'}"
}